module.exports = __webpack_public_path__ + "img/yaoqing.9870a3a3.png";